import HCPMarketingBanner from "../elements/hcp-marketing/main-banner";
import RecruitmentBanner from "../../images/banner/recruitment-marketing-banner.jpg";
import { RecruitmentForm } from "../elements/recruitment-form";
import { ContactSection } from "../elements/contact-section";
import { TargetingStrategy } from "../elements/targetingStrategy";
import { RecruitmentAdvantages } from "../elements/recruitment-marketing/recruitment-advantages";
import { RecruitmentTargetAdvantages } from "../elements/recruitment-marketing/recruitment-target-advantages";
import { HowWorksSection } from "../elements/how-works-section";
import { DetailsSection } from "../elements/details";

const recruitmentTypes = [
  { id: "Psychiatry", label: "Psychiatry" },
  { id: "Orthopedics", label: "Orthopedics" },
  { id: "Cardiology", label: "Cardiology" },
  { id: "Radiology", label: "Radiology" },
  { id: "Infectious Disease", label: "Infectious Disease" },
  { id: "Surgical Subspecialties", label: "Surgical Subspecialties" },
];

export const RecruitmentMarketing = () => {
  return (
    <section>
      <HCPMarketingBanner
        title="Recruitment Marketing with NPI-Level Precision"
        topic="Reach Hard-to-Fill HCP Roles—Directly and Effectively"
        description="Today's most effective healthcare recruiting doesn’t start with a job board—it starts with verified interest signals. DigiVidBIO’s NPI-targeted digital campaigns allow you to engage specific licensed healthcare professionals (HCPs) across their devices, using the same targeting precision trusted by top MedTech marketers.<br/><br/>🎯 Especially powerful for roles in underserved, rural, or high-turnover markets."
        image={RecruitmentBanner}
      />
      <RecruitmentTargetAdvantages />
      <RecruitmentAdvantages />
      <HowWorksSection />
      <DetailsSection
        title="Who This Is For"
        secondTitle="Recruitment teams hiring in specialties like:"
        items={recruitmentTypes}
      />
      <RecruitmentForm />
      <ContactSection />
    </section>
  );
};
